import { useGlobalSettings } from "../../../contexts/GlobalSettingsContext"

const useHiddenLanguages = (): string[] => {
  const globalSettings = useGlobalSettings()

  // Return an empty array if `hide_languages` is not defined or not an array
  return Array.isArray(globalSettings.hide_languages) ? globalSettings.hide_languages : []
}

export default useHiddenLanguages
